export default __webpack_public_path__ + "static/media/login@3x.0247fa2b.jpg";